import { DataGrid, GridActionsCellItem, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid'
import React, { Component } from 'react'
import { Box, Button, Divider, Fab, Modal, Snackbar, TextField, Typography, FormControl, InputLabel, Select, MenuItem, Autocomplete } from '@mui/material'
import { AddOutlined, DeleteOutline, RemoveRedEye, ThreeSixty, EditOutlined } from '@mui/icons-material'
import { LysepAPI } from '../../contexts/ApiContext'

export default class ExclusiveDatagrid extends Component {

    constructor(props) {
        super(props)
        this.AllowAdd = this.props.allowAdd ?? true
        this.Directory = props.directory
        this.UsesBackend = !(this.Directory === null || this.Directory === undefined)
        this.Columns = props.columns || []
        this.Primaries = (props.columns || []).filter(t => t.primary ?? false).map(t => t.field)
        this.Editable = (props.columns || []).filter(t => t.editable ?? false)
        this.deleteEnabled = this.Primaries.length > 0 && this.UsesBackend && (props.canDelete !== false)
        this.addEnabled = this.UsesBackend ? (this.Primaries.length > 0 && this.AllowAdd) : false

        let addContext = {}
        let emptyArgs = {}
        if (this.Editable && Array.isArray(this.Editable)) {
            this.Editable.forEach(column => {
                addContext[column.field] = column.type === "number" ? 0 : ""
                emptyArgs[column.field] = column.type === "number" ? 0 : ""
            });
        }

        // Calculate initial visibility model
        this.columnVisibilityModel = {};
        (props.columns || []).forEach(col => {
            if (col.visible === false) {
                this.columnVisibilityModel[col.field] = false;
            }
        });

        this.state = {
            rows: [],
            rowCount: 0,
            isLoading: false,
            paginationModel: {
                pageSize: 5,
                page: 0,
            },
            addContext: addContext,
            addModalOpen: false,
            snackBarMessage: "",
            snackBarOpen: false,
            search: this.props.search,
            editModalOpen: false,
            editContext: {}
        }

        this.paginationHandle = this.paginationHandle.bind(this)
        this.fetchData = this.fetchData.bind(this)
        this.snackBar = this.snackBar.bind(this)
        this.addModal = this.dataModal.bind(this)
        this.editModal = this.editDataModal.bind(this)
        this.openEditModal = this.openEditModal.bind(this)
        this.customToolbar = this.customToolbar.bind(this)
        this.addAccount = this.addAccount.bind(this)
        this.updateAccount = this.updateAccount.bind(this)
        this.deleteAccount = this.deleteAccount.bind(this)
    }
    componentDidMount() {
        // Only fetch data if using backend, otherwise data comes from props
        if (this.UsesBackend) {
            this.fetchData();
        } else {
            // Ensure loading is false when using client-side data
            this.setState({ isLoading: false });
        }
    }
    makeUniqueRows(rows) {
        if (!rows || !Array.isArray(rows)) {
            return [];
        }
        return rows.map(row => {
            if (!row.id && this.Primaries && this.Primaries.length > 0) {
                const id = this.Primaries.map(field => row[field]).join('-');
                return { ...row, id };
            }
            return row;
        });
    }
    componentDidUpdate(prevProps) {
        // Update local column definitions if props change
        if (prevProps.columns !== this.props.columns) {
            this.Columns = this.props.columns || []
            this.Primaries = (this.props.columns || []).filter(t => t.primary ?? false).map(t => t.field)
            this.Editable = (this.props.columns || []).filter(t => t.editable ?? false)
            this.forceUpdate();
        }

        // Only update if using backend
        if (this.UsesBackend && this.props.search?.code !== this.state.search?.code) {
            console.log("-----", this.props.search, this.state.search)
            this.setState((state) => {
                return {
                    ...state,
                    search: this.props.search
                }
            }, () => {
                this.fetchData()
            })
        }
        // If props.data changed and not using backend, ensure loading is false
        if (!this.UsesBackend && prevProps.data !== this.props.data) {
            this.setState({ isLoading: false });
        }
    }
    fetchData() {
        if (!this.UsesBackend) return;
        new Promise((resolve, reject) => {
            LysepAPI.get(this.Directory, {
                params: {
                    limit: this.state.paginationModel.pageSize,
                    offset: this.state.paginationModel.pageSize * this.state.paginationModel.page,
                    ...this.props.search
                }
            }).then(resp => {
                if (resp.data.state) {
                    let res = resp.data.data || []
                    this.setState((state) => {
                        return {
                            ...state,
                            isLoading: false,
                            rows: this.makeUniqueRows(res),
                            rowCount: res.length
                        }
                    }, () => {
                        resolve()
                    })
                } else {
                    this.showMessage("Öğe bulunamadı!")
                }
            }).catch((error) => {
                reject(error)
            })
        })

    }
    deleteAccount(params) {
        let args = {}
        this.Primaries.forEach(field => args[field] = params.row[field])

        const id = params.row.id;
        LysepAPI.delete(`${this.Directory}/${id}`).then(resp => {
            if (resp.data.state) {
                this.fetchData()
                this.showMessage(resp.data.message);
            } else {
                this.showMessage(`Silme işlemi başarısız: ${resp.data.message}`);
            }
        }).catch(error => {
            this.showMessage(`Silme işlemi sırasında hata oluştu: ${error.message}`);
        });
    }

    openEditModal(params) {
        // Fetch fresh data for the item
        if (this.UsesBackend && params.row.id) {
            LysepAPI.get(`${this.Directory}/${params.row.id}`).then(resp => {
                if (resp.data.state) {
                    this.setState({
                        editModalOpen: true,
                        editContext: { ...resp.data.data }
                    })
                } else {
                    this.showMessage(`Veri yüklenemedi: ${resp.data.message}`)
                }
            }).catch(err => {
                this.showMessage(`Veri yüklenirken hata oluştu: ${err.message}`)
            })
        } else {
            this.setState({
                editModalOpen: true,
                editContext: { ...params.row }
            })
        }
    }

    updateAccount() {
        let ValidationError = false
        let ValidationMessage = ""
        let args = this.state.editContext

        // Validate required fields
        this.Editable.forEach(t => {
            if (t.required) {
                let notMustbe = ""
                let value = args[t.field] ?? ""
                if (value === notMustbe) {
                    ValidationError = true
                    ValidationMessage = `${t.headerName} boş bırakılamaz.`
                }
            }
        })

        if (ValidationError) {
            this.showMessage(ValidationMessage)
            return;
        }

        LysepAPI.put(`${this.Directory}/${args.id}`, args).then(resp => {
            if (resp.data.state) {
                this.setState({
                    editModalOpen: false,
                    editContext: {}
                }, () => {
                    this.fetchData();
                    this.showMessage(`Güncelleme başarılı`);
                })
            } else {
                this.showMessage(`Hata: ${resp.data.message}`)
            }
        }).catch(error => {
            this.showMessage(`Güncelleme sırasında hata oluştu: ${error.message}`);
        })
    }
    paginationHandle(model) {
        this.setState((state) => {
            return {
                ...state,
                isLoading: this.UsesBackend, // Only set loading if using backend
                paginationModel: model
            }
        }, () => {
            this.fetchData()
            // If not using backend, ensure loading is false after state update
            if (!this.UsesBackend) {
                this.setState((state) => {
                    return {
                        ...state,
                        isLoading: false
                    }
                })
            }
        })
    }
    customToolbar() {
        return (
            <GridToolbarContainer>
                <Typography
                    variant='h4'
                    sx={{ margin: 2 }}
                >
                    {this.props.title}
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                {this.props.toolbar}
                <Divider sx={{ marginX: 1 }} orientation='vertical' />
                {this.addEnabled ?
                    (<Fab sx={{ margin: 2 }} color="primary" aria-label="add"
                        onClick={() => { this.setState((state) => { return { ...state, addModalOpen: true } }) }}
                    >
                        <AddOutlined />
                    </Fab>) :
                    <></>
                }


            </GridToolbarContainer>
        )
    }
    showMessage(message) {
        this.setState((state) => {
            return {
                ...state,
                snackBarOpen: true,
                snackBarMessage: message
            }
        }, () => {
        })

    }
    addAccount() {
        let ValidationError = false
        let ValidationMessage = ""
        let args = this.state.addContext
        this.Editable.forEach(t => {
            if (t.required) {
                let notMustbe = ""
                let value = args[t.field] ?? ""
                if (value === notMustbe) {
                    ValidationError = true
                    ValidationMessage = `${t.headerName} boş bırakılamaz.`
                }
            }
        })
        if (ValidationError) {
            this.showMessage(ValidationMessage)
            return;
        }
        LysepAPI.post(this.Directory, args).then(resp => {
            if (resp.data.state) {
                this.setState((state) => {
                    return {
                        ...state,
                        addModalOpen: false,
                        ...this.emptyArgs

                    }
                }, () => {
                    this.fetchData();
                    this.showMessage(`Created successfully`)

                })


            } else {
                this.showMessage(`Hata: ${resp.data.message}`)
            }
        })
    }
    dataModal() {
        return (
            <Modal
                open={this.state.addModalOpen}
                onClose={() => {
                    this.setState((state) => {
                        return {
                            ...state,
                            addModalOpen: false
                        }
                    })
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Ekle
                    </Typography>
                    {
                        this.Editable.map((column, i) => {
                            if (column.type === 'singleSelect' && column.valueOptions) {
                                return (
                                    <FormControl key={i} fullWidth sx={{ marginY: 1 }}>
                                        <Autocomplete
                                            disablePortal
                                            options={column.valueOptions}
                                            getOptionLabel={(option) => typeof option === 'object' ? option.label : option}
                                            isOptionEqualToValue={(option, value) => {
                                                const optVal = typeof option === 'object' ? option.value : option;
                                                const valVal = typeof value === 'object' ? value.value : value;
                                                return optVal == valVal;
                                            }}
                                            onChange={(event, newValue) => {
                                                const value = newValue ? (typeof newValue === 'object' ? newValue.value : newValue) : '';
                                                this.setState((prevState) => ({
                                                    addContext: {
                                                        ...prevState.addContext,
                                                        [column.field]: value
                                                    }
                                                }))
                                            }}
                                            renderInput={(params) => <TextField {...params} label={column.headerName} />}
                                        />
                                    </FormControl>
                                )
                            }
                            // Calculate dynamic props if the column has a dynamic property
                            let dynamicProps = {};
                            if (column.dynamic && typeof column.dynamic === 'function') {
                                dynamicProps = column.dynamic(this.state.addContext);
                            }

                            return (<TextField key={i} id="outlined-basic" sx={{ marginY: 1 }} onChange={(e) => {
                                const value = e.target.value
                                this.setState((prevState) => ({
                                    addContext: {
                                        ...prevState.addContext,
                                        [column.field]: value
                                    }
                                }))
                            }} fullWidth label={column.headerName} variant="outlined" {...dynamicProps} />)
                        })
                    }
                    <Box
                        display="flex"
                        alignItems="end"
                        sx={{ marginY: 2, width: "100%", justifyContent: "end" }}

                    >
                        <Button onClick={() => {
                            this.setState((state) => {
                                return {
                                    ...state,
                                    addModalOpen: false
                                }
                            })
                        }}>
                            İptal
                        </Button>
                        <Button
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            onClick={this.addAccount}
                            startIcon={<AddOutlined />}
                        >
                            Ekle
                        </Button>
                    </Box>
                </Box>

            </Modal>
        )
    }

    editDataModal() {
        return (
            <Modal
                open={this.state.editModalOpen}
                onClose={() => {
                    this.setState({ editModalOpen: false })
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Düzenle
                    </Typography>
                    {
                        this.Editable.map((column, i) => {
                            if (column.type === 'singleSelect' && column.valueOptions) {
                                return (
                                    <FormControl key={i} fullWidth sx={{ marginY: 1 }}>
                                        <Autocomplete
                                            disablePortal
                                            options={column.valueOptions}
                                            getOptionLabel={(option) => typeof option === 'object' ? option.label : option}
                                            isOptionEqualToValue={(option, value) => {
                                                const optVal = typeof option === 'object' ? option.value : option;
                                                const valVal = typeof value === 'object' ? value.value : value;
                                                // Handle the case where value is just the ID (not object)
                                                // When passed from value prop construction below
                                                return optVal == valVal;
                                            }}
                                            value={column.valueOptions.find(opt => (typeof opt === 'object' ? opt.value : opt) == (this.state.editContext[column.field])) || null}
                                            onChange={(event, newValue) => {
                                                const value = newValue ? (typeof newValue === 'object' ? newValue.value : newValue) : '';
                                                this.setState((prevState) => ({
                                                    editContext: {
                                                        ...prevState.editContext,
                                                        [column.field]: value
                                                    }
                                                }))
                                            }}
                                            renderInput={(params) => <TextField {...params} label={column.headerName} />}
                                        />
                                    </FormControl>
                                )
                            }
                            // Calculate dynamic props if the column has a dynamic property
                            let dynamicProps = {};
                            if (column.dynamic && typeof column.dynamic === 'function') {
                                dynamicProps = column.dynamic(this.state.editContext);
                            }

                            return (
                                <TextField
                                    key={i}
                                    id="outlined-basic"
                                    sx={{ marginY: 1 }}
                                    value={this.state.editContext[column.field] || ''}
                                    onChange={(e) => {
                                        const value = e.target.value
                                        this.setState((prevState) => ({
                                            editContext: {
                                                ...prevState.editContext,
                                                [column.field]: value
                                            }
                                        }))
                                    }}
                                    fullWidth
                                    label={column.headerName}
                                    variant="outlined"
                                    {...dynamicProps}
                                />
                            )
                        })
                    }
                    <Box
                        display="flex"
                        alignItems="end"
                        sx={{ marginY: 2, width: "100%", justifyContent: "end" }}
                    >
                        <Button onClick={() => {
                            this.setState({ editModalOpen: false })
                        }}>
                            İptal
                        </Button>
                        <Button
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            onClick={this.updateAccount}
                            startIcon={<EditOutlined />}
                        >
                            Kaydet
                        </Button>
                    </Box>
                </Box>
            </Modal>
        )
    }
    snackBar() {
        return (<Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={this.state.snackBarOpen}
            onClose={() => {
                this.setState((state) => {
                    return {
                        ...state,
                        snackBarOpen: false
                    }
                })
            }}
            autoHideDuration={5000}
            message={this.state.snackBarMessage}
        />)
    }
    render() {
        let Columns = [
            ...this.Columns
        ]
        let ActionsColumn = {
            field: 'actions',
            type: 'actions',
            width: 200,
            sortable: false,
            getActions: (params) => {
                let Actions = []
                if (this.deleteEnabled) {
                    Actions.push(<GridActionsCellItem icon={<DeleteOutline />} onClick={() => { this.deleteAccount(params) }} label="Delete" />)
                }
                if (this.Editable.length > 0 && this.UsesBackend) {
                    Actions.push(<GridActionsCellItem icon={<EditOutlined />} onClick={() => { this.openEditModal(params) }} label="Edit" />)
                }
                if (this.props.actions?.length > 0) {
                    Actions = [
                        ...Actions,
                        ...this.props.actions.map(t => t(params))
                    ]
                }
                return Actions
            }
        }
        if (this.props.startWithActions) {
            Columns = [
                ActionsColumn,
                ...Columns
            ]
        } else {
            Columns = [
                ...Columns,
                ActionsColumn
            ]
        }
        return (
            <Box sx={{ width: "100%", marginY: 2 }}>

                <DataGrid
                    rows={this.UsesBackend ? this.state.rows : this.props.data}
                    rowCount={this.UsesBackend ? (this.state.rowCount ?? 0) : (this.props.data?.length ?? 0)}
                    columns={Columns}
                    isCellEditable={() => false}
                    slots={{
                        toolbar: this.customToolbar
                    }}
                    autoHeight
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 5,
                                page: 0
                            },
                        },
                        columns: {
                            columnVisibilityModel: this.columnVisibilityModel
                        }
                    }}
                    loading={this.state.isLoading}
                    paginationMode={this.UsesBackend ? 'server' : 'client'}
                    paginationModel={this.state.paginationModel}
                    onPaginationModelChange={this.paginationHandle}
                    pageSizeOptions={[5]}
                >
                </DataGrid>
                {this.dataModal()}
                {this.editModal()}
                {this.snackBar()}
            </Box>



        )
    }
}
